export enum GalleryLayout {
	CAROUSEL = 'carousel',
	ALTCAROUSEL = 'alt-carousel',
	FLAT = 'flat',
	LIBRARY = 'library',
	PUZZLE = 'puzzle',
	PREVIEW_CAROUSEL = 'preview-carousel',
	CAROUSEL_PLAY = 'carousel-play',
}
